export default "__VITE_ASSET__pMTP1YS2__"